import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from 'react-bootstrap-5';
import { faEyeSlash as privateIcon } from '@fortawesome/pro-regular-svg-icons';

import BrokerGrossCommissionInputs from './inputs';

import './styles.scss';

export default function BrokerGrossCommissionWrapper({
  children,
  commission,
  disabled,
  invalid,
  label,
  required,
  transactionSide,
}) {
  return (
    <div
      className={classNames('form-group with-broker-gross-commission', {
        'has-error': invalid,
        required
      })}
    >
      <Form.Label>
        {label}
      </Form.Label>

      <div className="form-input-container">
        {children}
        {disabled ?
          <span className="d-flex align-items-center justify-content-center ms-2 text-muted">
            <span className="me-2">Private</span>
            <FontAwesomeIcon icon={privateIcon} />
          </span>
          :
          <BrokerGrossCommissionInputs commission={commission} transactionSide={transactionSide} />
        }
      </div>
    </div>
  );
}

BrokerGrossCommissionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  commission: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  transactionSide: PropTypes.string,
};
